import React from 'react';
import NavigationMenuAdd from "../../../menu-items/menu-add/menu-add";
import {QuickAddItemType} from "../../../../../app/quick-add/@types";

type Props = {

}


export default function MainMenu_ChatsAdd(props: Props) {


    if (!gd.ac.check.company.canCreateChat()) return null

    const onClick = (e?:React.SyntheticEvent) => {
        if (e) e.stopPropagation();
        gd.openNew(QuickAddItemType.CHAT)
    };


    return (
        <NavigationMenuAdd name="New chat" onClick={onClick}/>
    );
}
